<script setup>
import { maskName, exchangeRate } from '@/utils/index'
import loginView from '@/components/loginView/index.vue'
import { useUserStore } from '@/stores/userStore'
import { getDetail, setCollectApi, setDelCollectApi, setAddfollowApi, setDelfollowApi } from '@/apis/detail'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
const router = useRouter()
const { t, locale } = useI18n();
const userStore = useUserStore()
const props = defineProps({
    goods: {
        type: Object,
        default: () => { }
    },
    type: {
        type: String
    }

})
const loginModel = ref(false);
const dialogShopProduc=ref(false)
const productId=ref();
const ProductInfoDrawer=ref(false)
//商品加入购物车
const shopProduc=(id)=>{
   
    productId.value=id
    if(isMobile.value==true){
        ProductInfoDrawer.value=true
    }else{
        dialogShopProduc.value=true
    }
    console.log('商品id',id,dialogShopProduc.value)
}
const close=()=>{
    dialogShopProduc.value=false
}
const drawerClose=()=>{
    ProductInfoDrawer.value=false
}
const toDetail = (id) => {
    router.push({ path: '/detail/' + id })

}
const handleClose=()=>{
    loginModel.value=false
}
const isMobile=ref(false)
onMounted( () => {
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
});
</script>
<template>
    <div class="hot-item" @click="toDetail(goods.id)" v-if="type == 'yesterday'" >
        <img :src="goods.coverUrl || goods.images[0]" alt="" srcset="" class="hotImg">
        <div class="item-name">{{ goods.name }}</div>
        <div class="item-btn">Go</div>
    </div>
    <div class="sale-item" v-if="type == 'now'" @click="toDetail(goods.id)">
        <div class="item-img-box">
            <img :src="goods.coverUrl || goods.images[0]" alt="" srcset="" class="product-img">
            <div class="icon" @click.stop="shopProduc(goods.id)">
                <svg-icon icon-class="shoppingbag" style="width: 30px;height: 30px;" />
            </div>
        </div>
        <div class="item-info">
            <div class="item-name">{{ goods.name }}</div>
            <div class="item-price">
                <span v-if="userStore.exchangeRate.symbol == '￥'">¥ {{ goods.price }}</span>
                <span v-else> {{ exchangeRate(goods.price, userStore.exchangeRate.symbol, userStore.exchangeRate.rate)
                }}</span>
                <!-- <span>¥849</span> -->
            </div>
            <div class="item-salenum">
                <div class="num-text">{{ goods.salesCount > 10000 ? '10k+' : goods.salesCount > 1000 ? '1k+' :
                    goods.salesCount }}{{ ' ' }}{{ t('setup439') }}</div>
                <!-- <div class="gray-line"><div class="red-line"></div></div> -->
            </div>
        </div>
    </div>
    <el-dialog v-if="isMobile == false" v-model="dialogShopProduc" :show-close="false" width="988">
            <template #header="{ close }">
                <div class="my-header" style="text-align: end;">
                    <img src="../../../assets/images/closure.png" @click="dialogShopProduc = false"
                        style="width: 15px; height: 15px;" alt="" srcset="">

                </div>
            </template>
            <ProductPurchase :id="productId" @closes="dialogShopProduc = false"></ProductPurchase>
        </el-dialog>
        <el-drawer v-if="isMobile == true" v-model="ProductInfoDrawer" :with-header="false" direction="btt"
            :before-close="drawerClose" size="494px">
            <div class="closure" @click="ProductInfoDrawer = false">
                <img src="../../../assets/images/closure.png" alt="" srcset="">
            </div>
            <ProductPurchase :id="productId" @closes="ProductInfoDrawer = false"></ProductPurchase>
        </el-drawer>
    <el-dialog v-model="loginModel" width="350" :before-close="handleClose">
        <loginView :loginType="1" @close="handleClose" :type="1" v-if="loginModel"></loginView>
    </el-dialog>
    <!-- </RouterLink> -->
</template>

<style scoped lang="scss">
.nocollect {
    color: #b9b4b4;
}

.collect {
    color: #e26237;
}

.hot-item {
    background-color: #fff;
    width: calc(50% - 5px);
    margin-bottom: 10px;
    border-radius: 10px;
    text-align: center;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #11192D;
    font-style: normal;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding-top: 15px;
    box-sizing: border-box;
    height: 130px;

    .hotImg {
        width: 79px;
        height: 53px;
        object-fit: cover;
    }

    .item-name {
        width: calc(100% - 5px);
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #11192D;
        // padding-top: 10px;
        margin-top: 5px;
        box-sizing: border-box;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .item-btn {
        width: calc(100% - 20px);
        margin: 5px 10px 15px;
        height: 18px;
        line-height: 18px;
        background: #FF4848;
        border-radius: 9px;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 14px;
        color: #FFFFFF;
        font-style: normal;
    }
}

.sale-item {
    width: calc(20% - 14px);
    height: 327px;
    background: #FFFFFF;
    border-radius: 6px;
    padding: 8px;
    box-sizing: border-box;

    .item-img-box {
        width: 100%;
        padding-top: 100%;
        height: 0;
        position: relative;
        background: #F5F6F8;

        .product-img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            position: absolute;
            top: 0;
            left: 0;
        }

        .icon {
            position: absolute;
            right: 8px;
            bottom: 10px;
        }
    }

    .item-info {
        padding: 10px 4px;
        box-sizing: border-box;

        .item-name {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-family: MicrosoftYaHei;
            font-size: 16px;
            color: #11192D;
            text-align: left;
            font-style: normal;
        }

        .item-price {
            font-weight: bold;
            font-size: 24px;
            color: #FC3938;
            text-align: left;
            font-style: normal;
            padding: 10px 0 5px;

            // >span {
            //     font-size: 12px;
            //     color: #888888;
            //     line-height: 23px;
            //     text-align: left;
            //     font-style: normal;
            //     text-decoration-line: line-through;
            // }
        }

        .item-salenum {
            display: flex;
            align-items: center;

            .num-text {
                width: calc(100% - 10px);
                font-family: MicrosoftYaHei;
                font-size: 12px;
                color: #888888;
                text-align: left;
                font-style: normal;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }

            // .gray-line {
            //     width: calc(70% - 10px);
            //     position: relative;
            //     height: 8px;
            //     background: #F4EFEF;
            //     border-radius: 5px;

            //     .red-line {
            //         position: absolute;
            //         left: 0;
            //         top: 0;
            //         width: 30%;
            //         height: 8px;
            //         background: #FC3938;
            //         border-radius: 5px;
            //     }
            // }
        }
    }
}

@media (max-width: 768px) {
    .container {
        width: 100%;
    }

}
</style>